import { SampleMaterialEditForm, SampleMaterialEditFormValues } from 'features';
import { useTranslation } from 'i18n';
import { Dialog, DialogCloseButton, DialogContent, DialogTitle } from 'ui';

export const SampleMaterialEditDialog = ({
  open,
  onClose,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: SampleMaterialEditFormValues) => void;
}) => {
  const { t } = useTranslation('orders');

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>{t('sampleMaterialEditDialog.title')}</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <SampleMaterialEditForm onSubmit={onSubmit} />
      </DialogContent>
    </Dialog>
  );
};
